import { z } from 'zod';

export const ModelContext = z
  .object({
    organizationId: z.string(),
    databaseId: z.string(),
    databaseRevisionId: z.string(),
  })
  .describe('ModelContext');
